import type { ChatMessage, Conversation, ConversationMember, MessageRecord } from '../types'

const MOCK_CHAT_IMAGE =
  'data:image/svg+xml,' +
  encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 320 180">
    <rect width="320" height="180" fill="#f4f7fb"/>
    <rect x="16" y="16" width="120" height="148" rx="6" fill="#fff" stroke="#d9e2ec"/>
    <rect x="28" y="28" width="96" height="10" rx="2" fill="#c5d0dc"/>
    <rect x="28" y="48" width="72" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="28" y="64" width="88" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="28" y="80" width="64" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="152" y="16" width="152" height="148" rx="6" fill="#fff" stroke="#d9e2ec"/>
    <rect x="164" y="32" width="128" height="12" rx="2" fill="#1677ff"/>
    <rect x="164" y="56" width="128" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="164" y="72" width="96" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="164" y="88" width="112" height="8" rx="2" fill="#e4ebf2"/>
    <rect x="164" y="120" width="128" height="28" rx="4" fill="#f0f5ff"/>
  </svg>`)

function hoursAgo(hours: number) {
  const date = new Date()
  date.setHours(date.getHours() - hours)
  return date.toISOString()
}

function minutesAgo(minutes: number) {
  const date = new Date()
  date.setMinutes(date.getMinutes() - minutes)
  return date.toISOString()
}

export const mockMessages: MessageRecord[] = [
  {
    id: 'm1',
    title: '计件报工审批通过',
    content:
      '张三提交 2026-06-30 白班计件共 12 条明细，已由李主管审批通过。可在计件 Tab 查看详情并导出。',
    type: 'business',
    read: false,
    sender: 'MES 系统',
    createTime: minutesAgo(25),
    bizTab: 'piece',
    payload: { reportDate: '2026-06-30', shift: 'day' },
  },
  {
    id: 'm2',
    title: '工序父级关系变更待确认',
    content:
      '工序「钻孔」申请绑定父工序，需工艺员在工序 Tab 中确认。若 24 小时内未处理将自动驳回。',
    type: 'business',
    read: false,
    sender: '工艺管理',
    createTime: hoursAgo(2),
    bizTab: 'process',
    payload: { processCode: 'DRILL-01' },
  },
  {
    id: 'm3',
    title: '用户批量导入完成',
    content:
      '人事部上传的 28 条用户 Excel 已导入成功，其中 2 条部门映射需人工复核，请前往用户表 Tab 处理。',
    type: 'business',
    read: false,
    sender: '系统导入',
    createTime: hoursAgo(5),
    bizTab: 'user',
    payload: { importCount: 28, failedCount: 2 },
  },
  {
    id: 'm4',
    title: 'LOV 字典发布提醒',
    content: '「工序类型」字典新增枚举值「外协」已保存，请发布到生产环境后生效。',
    type: 'system',
    read: true,
    sender: '字典中心',
    createTime: hoursAgo(8),
    bizTab: 'lov',
  },
  {
    id: 'm5',
    title: '系统维护通知',
    content:
      '计划于 2026-07-02 02:00–04:00 进行数据库维护，期间部分查询接口可能短暂不可用，请提前安排导出任务。',
    type: 'system',
    read: true,
    sender: '运维中心',
    createTime: hoursAgo(12),
  },
  {
    id: 'm6',
    title: '数据源连接异常',
    content:
      '测试环境 Oracle 数据源连接超时（3 次重试失败），请检查网络与白名单配置。可在数据源配置 Tab 重新测试连接。',
    type: 'alert',
    read: false,
    sender: '监控告警',
    createTime: hoursAgo(18),
    bizTab: 'data-source',
    payload: { datasourceId: 'ds-oracle-test' },
  },
  {
    id: 'm7',
    title: '计件单价规则已更新',
    content:
      'Aviator 规则「大尺寸 AB 板」单价系数由 1.2 调整为 1.35，请确认是否影响在途报工，必要时在规则+Aviator Tab 回滚。',
    type: 'business',
    read: true,
    sender: '规则引擎',
    createTime: hoursAgo(24),
    bizTab: 'rule-aviator',
  },
  {
    id: 'm8',
    title: '菜单权限变更生效',
    content: '已为「质检组」开放计件查询菜单，变更已同步至所有在线节点。',
    type: 'system',
    read: true,
    sender: '权限中心',
    createTime: hoursAgo(36),
    bizTab: 'menu',
  },
]

const HE_SHANGHAI_ID = 'c-he-shanghai'

const heShanghaiMessages: ChatMessage[] = [
  {
    id: 'hs-1',
    conversationId: HE_SHANGHAI_ID,
    from: 'self',
    kind: 'text',
    content: 'data0028.EXP_DATE, data0028.STATUS, data0028.Auth_Date;',
    createTime: hoursAgo(48),
    read: true,
  },
  {
    id: 'hs-2',
    conversationId: HE_SHANGHAI_ID,
    from: 'peer',
    kind: 'image',
    content: MOCK_CHAT_IMAGE,
    fileName: '4201000278',
    createTime: hoursAgo(20),
    senderName: '何上海',
  },
  {
    id: 'hs-4',
    conversationId: HE_SHANGHAI_ID,
    from: 'peer',
    kind: 'text',
    content:
      '唐总，开料利用率视图我重新优化过，你原来的字段名称还是按你原来的，新增的我也用中文标识了',
    createTime: hoursAgo(18),
    senderName: '何上海',
  },
  {
    id: 'hs-5',
    conversationId: HE_SHANGHAI_ID,
    from: 'self',
    kind: 'text',
    content: '👌',
    createTime: hoursAgo(16),
    read: true,
  },
  {
    id: 'hs-6',
    conversationId: HE_SHANGHAI_ID,
    from: 'self',
    kind: 'text',
    content: '何总，客户表是哪个，需要客户编码和客户名称',
    createTime: hoursAgo(1),
    read: true,
  },
  {
    id: 'hs-7',
    conversationId: HE_SHANGHAI_ID,
    from: 'peer',
    kind: 'text',
    content: 'DATA0010表',
    createTime: minutesAgo(8),
    senderName: '何上海',
  },
]

const QTIME_GROUP_ID = 'c-qtime'

const qtimeMembers: ConversationMember[] = [
  { id: 'user:p1', name: '周国庆', kind: 'user', username: 'zgq', email: 'zgq@example.com' },
  { id: 'user:p2', name: '唐立杰', kind: 'user', username: 'tlj', email: 'tlj@example.com' },
  { id: 'user:p3', name: '吴予骥', kind: 'user', username: 'wyj', email: 'wyj@example.com' },
  { id: 'user:p4', name: '李晓明', kind: 'user', username: 'lxm', email: 'lxm@example.com' },
  { id: 'user:p5', name: '王芳', kind: 'user', username: 'wf', email: 'wf@example.com' },
  { id: 'user:p6', name: '陈静', kind: 'user', username: 'cj', email: 'cj@example.com' },
]

const qtimeMessages: ChatMessage[] = [
  {
    id: 'qt-1',
    conversationId: QTIME_GROUP_ID,
    from: 'peer',
    kind: 'text',
    content: '本周 Q-time 异常单请下班前同步到群里',
    createTime: hoursAgo(6),
    senderName: '周国庆',
  },
  {
    id: 'qt-2',
    conversationId: QTIME_GROUP_ID,
    from: 'peer',
    kind: 'file',
    content: MOCK_CHAT_IMAGE,
    fileName: '三德冠贴装作业单停留时间.xlsx',
    createTime: hoursAgo(2),
    senderName: '吴予骥',
  },
  {
    id: 'qt-3',
    conversationId: QTIME_GROUP_ID,
    from: 'self',
    kind: 'text',
    content: '收到，我先核对停留时间字段',
    createTime: minutesAgo(20),
    read: true,
  },
]

export const mockChatConversations: Conversation[] = [
  {
    id: HE_SHANGHAI_ID,
    kind: 'direct',
    title: '何上海',
    subtitle: '信息部 · ERP工程师',
    online: true,
    lastPreview: 'DATA0010表',
    lastTime: heShanghaiMessages[heShanghaiMessages.length - 1]!.createTime,
    unread: 1,
    sender: '何上海',
    members: [{ id: 'user:he-shanghai', name: '何上海', kind: 'user' }],
  },
  {
    id: QTIME_GROUP_ID,
    kind: 'group',
    title: '工序Q-time管控',
    subtitle: `${qtimeMembers.length} 人`,
    lastPreview: '收到，我先核对停留时间字段',
    lastTime: qtimeMessages[qtimeMessages.length - 1]!.createTime,
    unread: 0,
    sender: '我',
    members: qtimeMembers,
  },
]

export const mockChatThreads: Record<string, ChatMessage[]> = {
  [HE_SHANGHAI_ID]: heShanghaiMessages,
  [QTIME_GROUP_ID]: qtimeMessages,
}
